export {
  default,
  ModalContextProvider,
  type OwnProps as ModalContextProps
} from './ModalContext';
